import { render, staticRenderFns } from "./DiyForm.vue?vue&type=template&id=766f4f2a&scoped=true&"
import script from "./DiyForm.vue?vue&type=script&lang=js&"
export * from "./DiyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../salespro-dev/salespro-dev/sources/client/salespro-dev-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766f4f2a",
  null
  
)

export default component.exports